import React from "react";
import DataGridPersonnel from "../clinique/DataGridAgent";
import DashboardLayoutBranding from "../clinique/DashboardLayoutBranding";
import useAuthStore from '../store/authStore';
import { CircularProgress, Box } from '@mui/material';
import { useRoutes } from 'react-router-dom';
import ConnectedAgentProfilePage from "../clinique/pages/ConnectedAgentProfile";
import PrescriptionsHistory from "../clinique/PrescriptionsHistory";

const AdminChildren = [
  { index: true, element: <DataGridPersonnel /> },
  { path: "personnel", element: <DataGridPersonnel /> },
  { path: "profile", element: <ConnectedAgentProfilePage /> },
];

const AgentChildren = [
  { index: true, element: <PrescriptionsHistory /> },
  { path: "prescriptions", element: <PrescriptionsHistory /> },
  { path: "profile", element: <ConnectedAgentProfilePage /> },
];

const DynamicRoutes = () => {
  const user = useAuthStore(state => state.user);
  
  const routes = React.useMemo(() => {
    switch (user?.role) {
      case 'admin_pharmacie':
        return AdminChildren;
      case 'agent_pharmacie':
        return AgentChildren;
      default:
        return [];
    }
  }, [user?.role]);

  return useRoutes(routes);
};

const LoadingWrapper = ({ children }) => {
  const user = useAuthStore(state => state.user);

  if (!user?.role) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return children;
};

const PharmacieRoutes = [
  {
    path: "*",
    element: (
      <LoadingWrapper>
        <DashboardLayoutBranding>
          <DynamicRoutes />
        </DashboardLayoutBranding>
      </LoadingWrapper>
    ),
  },
];

export default PharmacieRoutes;
